module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABxSURBVDhPY/hPImD49+/P1/c7P79e8vn1Mnzo1aLvn0+DNfz9/fHVvPdPWt4/bceD3j1u/PphB9SGT68WvX/a8eFZDx70/knr1w+7RjWgqUBDg1sDGUnj6/sdn14v/vR6GT70auH3z6dAGoCYBPD/PwBJxo0TNxlDMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/electric-node.png
// module id = 983
// module chunks = 0